import { create } from 'zustand'
import type { StoreFile } from '@fowix/types'

export type File = StoreFile

interface Store {
  sessionId: string | null
  files: StoreFile[]
  expiresAt: string | null
  setSessionId: (sessionId: string) => void
  setFiles: (files: File[] | ((prev: File[]) => File[])) => void
  setExpiresAt: (expiresAt: string | null) => void
  toggleFileSelection: (fileId: string) => void
  updateFileOrder: (fileId: string, order: number) => void
  clearSelection: () => void
}

export const useStore = create<Store>((set) => ({
  sessionId: null,
  files: [],
  expiresAt: null,
  setSessionId: (sessionId) => set({ sessionId }),
  setFiles: (files) => set((state) => ({
    ...state,
    files: typeof files === 'function' ? files(state.files) : files,
  })),
  setExpiresAt: (expiresAt) => set((state) => ({ ...state, expiresAt })),
  toggleFileSelection: (fileId) =>
    set((state) => ({
      files: state.files.map((file) =>
        file.id === fileId
          ? { ...file, selected: !file.selected, order: !file.selected ? null : file.order }
          : file
      ),
    })),
  updateFileOrder: (fileId, order) =>
    set((state) => ({
      files: state.files.map((file) =>
        file.id === fileId ? { ...file, order } : file
      ),
    })),
  clearSelection: () =>
    set((state) => ({
      files: state.files.map((file) => ({ ...file, selected: false, order: null })),
    })),
})) 